
import { computed, defineComponent, Ref } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ImageFileModel } from '@/types/B2BcontentServerContract';
import useStore from '@/shared/stores/useStore';

export default defineComponent({
    name: 'StoreDetail',
    components: {},
    props: {
        id: {
            type: String,
            required: true,
        },
        heading: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const labels = useBlockLabels();
        const store = useStore(props.id);

        const image: Ref<ImageFileModel> = computed(() => {
            return store.value?.image ?? {} as ImageFileModel;
        });

        return {
            labels,
            store,
            image,
        };
    },
});
